<template>
    <div class="loyalty-card">
        <div class="top-block">
            <img src="../../../assets/images/ps.svg" style="width: 26px">
            目前點數還有 <span class="red">{{ pointAmount }}</span> 點
        </div>
        <div/>
        <div class="coupon-item" v-for="(item, index) in dataList" :key="index"
             @click="goDetail(item)">
            <div class="cover coupon-cover">
                <el-image
                        :src="item.imageUrl"
                        fit="cover">
                </el-image>
                <div class="point">{{ item.showExchangeInfo }}</div>
            </div>

            <div class="title">
                {{ item.convertName }}
            </div>
            <div class="date" v-if="item.startAt !== '' && item.endAt !== ''">{{ item.startAt }}~{{ item.endAt }}</div>

            <el-button type="primary"
                       @click.stop="getConvertInfo(item)"
                       round>兌換
            </el-button>
        </div>
        <points-exchange-dialog :value="showModel"
                                :convertData="convertData"
                                :appendToBody="isWeb"
                                :isWeb="isWeb"
                                @result="onPointsExchangeDialogResult"/>

        <!--網頁版用-->
        <CommDialog :value="isShowDialog"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <LoyaltyCardExchangeDetail isWeb :dataTokenWeb="dataTokenWeb" @close="onCommDialogClose" class="web-content" v-if="isShowDialog"/>

        </CommDialog>
    </div>
</template>

<script>
    import PointsExchangeDialog from "./PointsExchangeDialog";
    import * as constDefine from "@/store/constDefine";
    import CommDialog from '@/components/CommDialog.vue';
    import LoyaltyCardExchangeDetail from "@/views/gift/LoyaltyCardExchangeDetail";

    export default {
        name: "LoyaltyCardItem",
        props: ['dataList', 'userPoint', 'loyaltyCardId' , 'isWeb'],
        components: {
            PointsExchangeDialog,
            CommDialog,
            LoyaltyCardExchangeDetail,
        },
        data() {
            return {
                pointAmount: this.userPoint,    //目前點數
                convertData: {
                    pointAmount: this.userPoint,
                    id: 0,
                    type: 0,                        //兌換種類
                    typeId: 0,                      //對應的id
                    costPoint: 0,                   //單次要扣除多少點數
                    costPrice: 0,                   //單次要扣除多少費用
                    convertCount: 0,                //單次兌換數量
                    convertMethod: 0,               //兌換方法
                    unit: "",                       //單位
                    exchangeMethod: 0,              //1:免費兌換、2:加價兌換
                },
                showModel: false,               //集點卡兌換彈框

                isShowDialog: false,
                dataTokenWeb: '',

            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            getConvertInfo: function (item) {
                this.convertData.id = item.loyaltyCardConvertId;
                this.convertData.type = item.loyaltyCardConvertType;
                this.convertData.typeId = item.loyaltyCardConvertTypeId;
                this.convertData.convertMethod = item.convertMethod;
                this.convertData.unit = item.unit;
                this.convertData.exchangeMethod = item.exchangeMethod;
                if (item.exchangeMethod === constDefine.FREE_CONVERT) {
                    this.convertData.costPoint = item.freeConvertPoint;
                    this.convertData.costPrice = 0;
                    this.convertData.convertCount = item.freeConvertCount;
                } else if (item.exchangeMethod === constDefine.PURCHASE_CONVERT) {
                    this.convertData.costPoint = item.purchaseConvertPoint;
                    this.convertData.costPrice = item.purchaseConvertPrice;
                    this.convertData.convertCount = item.purchaseConvertCount;
                }

                this.showModel = true
            },
            //集點卡兌換dialog送出
            onPointsExchangeDialogResult(result) {
                this.showModel = false;
                if (result) {
                    this.$emit('triggerEvent', {
                        "event": "setupData",
                    });
                }
            },
            goDetail(item){
                if(!this.isWeb){
                    this.$router.push({name: 'LoyaltyCardExchangeDetail', query: {i: item.loyaltyCardConvertId, e: item.exchangeMethod}})
                }else {
                    //單店網頁版用
                    this.dataTokenWeb = {i: item.loyaltyCardConvertId, e: item.exchangeMethod}
                    this.isShowDialog = true
                }
            },

            onCommDialogClose() {
                this.isShowDialog = false;
            },
        }
    }
</script>

<style lang="less" scoped>

</style>